const MODAL_TYPES = {
  NAV_ACTIONS_LIST: 'NAV_ACTIONS_LIST',
  SCHOOL_SELECTION: 'SCHOOL_SELECTION'
}

export { MODAL_TYPES }
